import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';

function List() {

    const pathFrontEnd = '/businessmanagers/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}businessmanagers/delete`,
        endpoint: config.endpoints.backend + 'businessmanagers/getall'
    }

    let list = {
        labelTitle: 'Lista de Gestor de Empresa',
        labelTitleButtonAdd: 'Incluir novo gestor de empresa',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        columns: [
            {
                name: 'name',
                label: 'Nome do Gestor'
            },
            {
                name: 'company',
                label: 'Empresa'
            },
            {
                name: 'status',
                label: 'Status'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
